/**
 * Distinguer « le serveur a refusé » de « le serveur est injoignable ».
 *
 * Sans cette distinction, une coupure réseau était traitée comme une session
 * expirée : redirection vers `/login`, alors que la session est parfaitement
 * valide et que seule la connectivité manque.
 */
import { AxiosError } from "axios";

/**
 * Vrai quand la requête n'a jamais obtenu de réponse : réseau coupé, DNS,
 * serveur injoignable, délai dépassé. Faux pour un 401/403/500 — dans ces cas
 * le serveur a bien répondu et son verdict fait autorité.
 */
export function isNetworkError(error: unknown): boolean {
  if (!(error instanceof AxiosError)) {
    // Hors axios (fetch natif, échec de résolution), on ne suppose rien : seul
    // un statut HTTP prouve que le serveur a parlé.
    return error instanceof TypeError && /network|fetch/i.test(error.message);
  }
  if (error.response) return false;
  return (
    error.code === AxiosError.ERR_NETWORK ||
    error.code === AxiosError.ECONNABORTED ||
    error.code === AxiosError.ETIMEDOUT ||
    // Requête émise, aucune réponse : le cas générique d'une coupure.
    Boolean(error.request)
  );
}
